import routePaths from 'const/routePaths'
import { userAccountInfo } from 'helpers/user'
import i18n from 'lang/i18n'
import { ClientAccountTypes } from 'typings/brands'
import { MainMenuProps } from 'typings/menu'

export const menuItems = (): Array<MainMenuProps> => [
  /* Account Summary */
  {
    menuId: 'summary',
    path: routePaths.summary,
    menuName: i18n({ menuName: 'summary' }) as string,
    isSubMenu: false,
    unSupportedAccountType: []
  },
  /* Payments */
  {
    menuId: 'payments',
    path: routePaths.makePayment,
    menuName: i18n({ frequentlyAskedQuestions: 'payments' }) as string,
    isSubMenu: true,
    unSupportedAccountType: [],
    subMenuItems: [
      {
        menuId: 'makePayment',
        path: routePaths.makePayment,
        menuName: i18n({ menuName: 'makePayment' }) as string,
        unSupportedAccountType: [
          'lowesbrc',
          'samsplcc',
          'samsdualcard',
          'flooranddecorbrc',
          'p66brc'
        ]
      },
      {
        menuId: 'schedulePayment',
        unSupportedAccountType: ['lowesprox', 'samsprox'],
        path: routePaths.makePayment,
        menuName: i18n({ menuName: 'schedulePayment' }) as string
      },
      {
        menuId: 'viewPayment',
        path: routePaths.viewPayment,
        menuName: i18n({ menuName: 'viewPayment' }) as string,
        unSupportedAccountType: [
          'lowesbrc',
          'samsplcc',
          'samsdualcard',
          'flooranddecorbrc',
          'p66brc'
        ]
      },
      {
        menuId: 'paymentHistory',
        unSupportedAccountType: ['lowesprox', 'samsprox'],
        path: routePaths.viewPayment,
        menuName: i18n({ menuName: 'paymentHistory' }) as string
      }
    ]
  },
  /* Billing */
  {
    menuId: 'billing',
    path: '/billing',
    unSupportedAccountType: [],
    menuName: i18n({ menuName: 'billing' }) as string,
    isSubMenu: true,
    subMenuItems: [
      {
        menuId: 'invoice',
        unSupportedAccountType: [
          'lowesbrc',
          'samsplcc',
          'samsdualcard',
          'flooranddecorbrc',
          'p66brc'
        ],
        path: routePaths.invoice,
        menuName: i18n({ invoice: 'invoices' }) as string
      },
      {
        menuId: 'statements',
        unSupportedAccountType: [
          'lowesbrc',
          'samsplcc',
          'samsdualcard',
          'flooranddecorbrc',
          'p66brc'
        ],
        path: routePaths.statement,
        menuName: i18n({ menuName: 'statements' }) as string
      },
      {
        menuId: 'credit',
        unSupportedAccountType: [
          'lowesbrc',
          'samsplcc',
          'samsdualcard',
          'flooranddecorbrc',
          'p66brc'
        ],
        path: routePaths.credit,
        menuName: i18n({ menuName: 'credits' }) as string
      },
      {
        menuId: 'transactions',
        unSupportedAccountType: ['lowesprox', 'samsprox'],
        path: routePaths.transactions,
        menuName: i18n({ menuName: 'transactions' }) as string
      },
      {
        menuId: 'estatement',
        unSupportedAccountType: ['lowesprox', 'samsprox'],
        path: routePaths.statement,
        menuName: i18n({ menuName: 'eStatements' }) as string
      }
    ]
  },
  /* Account Management */
  {
    menuId: 'accountMgmt',
    path: '/accountmgmt',
    unSupportedAccountType: [],
    menuName: i18n({ menuName: 'accountMgmt' }) as string,
    isSubMenu: true,
    subMenuItems: [
      {
        menuId: 'editUserInformation',
        unSupportedAccountType: [],
        path: routePaths.editUser,
        menuName: i18n({ menuName: 'editUserInfo' }) as string
      },
      {
        menuId: 'editBusinessInfo',
        unSupportedAccountType: [],
        path: routePaths.editBusinessInfo,
        menuName: i18n({ editBusinessInformation: 'title' }) as string
      },
      {
        menuId: 'manageUser',
        unSupportedAccountType: [],
        path: routePaths.manageUser,
        menuName: i18n({ menuName: 'manageUser' }) as string
      },
      {
        menuId: 'manageBuyers',
        unSupportedAccountType: [
          'lowesbrc',
          'samsplcc',
          'samsdualcard',
          'flooranddecorbrc',
          'p66brc'
        ],
        path: routePaths.manageBuyers,
        menuName: i18n({ menuName: 'manageBuyers' }) as string
      },
      {
        menuId: 'managePayment',
        unSupportedAccountType: [],
        path: routePaths.managePayment,
        menuName: i18n({ menuName: 'managePayment' }) as string
      },
      {
        menuId: 'manageLinkedAccounts',
        unSupportedAccountType: [],
        path: routePaths.manageLinkedAccounts,
        menuName: i18n({ menuName: 'manageLinkedAccounts' }) as string
      },
      {
        menuId: 'lostCard',
        unSupportedAccountType: [
          'lowesprox',
          'lowesbrc',
          'samsprox',
          'samsplcc',
          'samsdualcard',
          'flooranddecorbrc'
        ],
        path: routePaths.lostCard,
        menuName: i18n({ menuName: 'Report Lost or Stolen' }) as string
      },
      {
        menuId: 'requestBuyerCards',
        path: routePaths.requestBuyerCards,
        unSupportedAccountType: ['lowesprox', 'samsplcc', 'samsprox', 'p66brc'],
        menuName: i18n({ menuName: 'requestBuyerCards' }) as string
      },
      {
        menuId: 'manageChildAccount',
        unSupportedAccountType: [
          'lowesbrc',
          'samsplcc',
          'samsdualcard',
          'flooranddecorbrc',
          'p66brc'
        ],
        path: routePaths.manageChildAccount,
        menuName: i18n({ menuName: 'manageChildAccount' }) as string
      },
      {
        menuId: 'invoiceBillPay',
        unSupportedAccountType: [
          'lowesbrc',
          'samsdualcard',
          'samsplcc',
          'flooranddecorbrc',
          'p66brc'
        ],
        path: routePaths.invoiceBillPay,
        menuName: i18n({ menuName: 'invoiceBillPay' }) as string
      },
      {
        menuId: 'ibpStatus',
        unSupportedAccountType: [
          'lowesbrc',
          'samsdualcard',
          'samsplcc',
          'flooranddecorbrc',
          'p66brc'
        ],
        path: routePaths.ibpStatus,
        menuName: i18n({ menuName: 'ibpStatus' }) as string
      },
      {
        menuId: 'viewStatement',
        unSupportedAccountType: [],
        path: routePaths.statement,
        menuName: i18n({ menuName: 'viewStatement' }) as string
      },
      {
        menuId: 'creditLineIncrease',
        unSupportedAccountType: [],
        path: routePaths.increaseCreditLine,
        menuName: i18n({ menuName: 'creditLineIncrease' }) as string
      },
      {
        menuId: 'enrollEmailStatement',
        unSupportedAccountType: [],
        path: routePaths.emailStatement,
        menuName: i18n({ statement: 'enrollIneStatements' }) as string
      },
      {
        menuId: 'taxforms',
        unSupportedAccountType: ['flooranddecorbrc'],
        path: routePaths.taxForms,
        menuName: i18n({ menuName: 'taxforms' }) as string
      },
      {
        menuId: 'editJobName',
        unSupportedAccountType: [
          'lowesbrc',
          'samsplcc',
          'samsdualcard',
          'flooranddecorbrc',
          'p66brc'
        ],
        path: routePaths.editJobName,
        menuName: i18n({ menuName: 'editJobName' }) as string
      },
      {
        menuId: 'closeAccount',
        unSupportedAccountType: ['samsplcc', 'samsprox'],
        path: routePaths.closeAccount,
        menuName: i18n({ closeAccount: 'title' }) as string
      },
      {
        menuId: 'logout',
        unSupportedAccountType: [],
        path: routePaths.logout,
        menuName: i18n({ menuName: 'logout' }) as string
      }
    ]
  },
  /* Help Center */
  {
    menuId: 'helpCenter',
    path: '/helpcenter',
    unSupportedAccountType: [],
    menuName: i18n({ menuName: 'helpCenter' }) as string,
    isSubMenu: true,
    subMenuItems: [
      {
        menuId: 'userGuide',
        unSupportedAccountType: [],
        path: routePaths.userGuide,
        menuName: i18n({ menuName: 'userGuide' }) as string
      },
      {
        menuId: 'contactUs',
        unSupportedAccountType: [],
        path: routePaths.contactUs,
        menuName: i18n({ frequentlyAskedQuestions: 'contactUs' }) as string
      }
    ]
  }
]

const getMenuItems = (clientName: string): Array<MainMenuProps> => {
  const { accountType, cardType } = userAccountInfo
  let type = `${clientName}${accountType}`.toLowerCase()
  if (clientName.toLowerCase() === 'sams' && cardType) {
    type = `${clientName}${cardType}`.toLowerCase()
  }
  return menuItems().map(item => {
    return {
      ...item,
      subMenuItems: item.subMenuItems
        ? item.subMenuItems.filter(
            subMenuItem =>
              !subMenuItem.unSupportedAccountType.includes(
                type as ClientAccountTypes
              )
          )
        : []
    }
  })
}

export default getMenuItems
